import { makeStyles } from 'tss-react/mui';
import { themeProps } from './theme';

const useStyles = makeStyles()((theme) => ({
  occupancyPill: {
    border: 'none',
    marginLeft: '5px',
    marginRight: '5px',
  },
  lockedIcon: {
    color: theme.palette.warning.main,
    background: 'white !important',
  },
  timeSelectionContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
      width: '90%',
      margin: 'auto',
    },
  },
  plotContainer: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('md')]: {
      width: '95vw',
      padding: '5px',
      display: 'block !important',
    },
  },
  toggleBtn: {
    fontSize: themeProps.textSize.small,
    padding: '0 10px',
    textTransform: 'capitalize',
  },
  centered: {
    textAlign: 'center',
    alignSelf: 'center',
  },
  sensorsListContainer: {
    [theme.breakpoints.up('lg')]: {
      paddingBottom: '50px',
      maxHeight: 'calc(100vh - 475px)',
      overflowY: 'scroll',
      overflowX: 'hidden',
    },
  },
}));

export default useStyles;
